var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";
import { forwardRef } from "react";

var SvgAboundMarkLeft = function SvgAboundMarkLeft(_ref, ref) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    preserveAspectRatio: "none",
    overflow: "visible",
    style: {
      display: "block"
    },
    width: 9.51529,
    height: 15.6215,
    viewBox: "0 0 9.51529 15.6215",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M6.16456 9.21229L5.97633 9.91815V9.93698L5.25164 12.2993L5.12929 12.7322L4.15049 15.6215H0L3.69874 5.6359C4.34813 5.89942 5.06341 6.18177 5.57163 6.58647C5.83516 6.80293 6.05162 7.05704 6.16456 7.35821C6.39044 7.95114 6.32456 8.59113 6.16456 9.21229Z",
    fill: "url(#paint0_linear_0_43)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M9.51524 3.48632e-06C9.12937 0.941158 8.54585 2.50347 7.9341 3.75521C7.54823 4.55519 7.14353 5.22341 6.78589 5.50576C6.4659 5.75987 6.03297 5.82575 5.56239 5.80693C4.98829 5.77869 4.3483 5.60928 3.75537 5.44929L5.77886 3.48632e-06H9.51524Z",
    fill: "url(#paint1_linear_0_43)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_0_43",
    x1: 3.86345,
    y1: 5.79062,
    x2: -2.59142,
    y2: 13.385,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF6E64"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8246FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_0_43",
    x1: 7.28183,
    y1: 0.0900204,
    x2: 4.09413,
    y2: 5.9737,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF6E64"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8246FF"
  })))));
};

var ForwardRef = /*#__PURE__*/forwardRef(SvgAboundMarkLeft);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/abound-mark-left.dad72a8ec15142cdd2187727b5288a5b.svg";